import gql from "graphql-tag";

export default gql`
  subscription SubscribeToLocationRefillRequest {
    subscribeToLocationRefillRequest {
      id
    }
  }
`;
